const api = {
  Login: process.env.VUE_APP_CMS_SYSTEM + '/sys/login',
  Logout: process.env.VUE_APP_CMS_SYSTEM + '/sys/logout',
  ForgePassword: process.env.VUE_APP_CMS_SYSTEM + '/auth/forge-password',
  Register: process.env.VUE_APP_CMS_SYSTEM + '/auth/register',
  SendSms: process.env.VUE_APP_CMS_SYSTEM + '/account/sms',
  // get my info
  UserInfo: process.env.VUE_APP_CMS_SYSTEM + '/user/info'
};
export default api;
